export default function translateMsg (msg) {
  // 映射表
  const map = new Map([
    ['success', '操作成功']
  ])
  // 获取映射关系
  let cmsg = map.get(msg)
  if (!cmsg) {
    return msg
  } else {
    return cmsg
  }
}



// WEBPACK FOOTER //
// ./src/service/translateMsg.js